module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "container pt-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('Settings.modifyInfo.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.name,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.companyName') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.name = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.address,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.address = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.city,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.city') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.city = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.postcode,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.zipCode') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.postcode = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-select', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.province,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.province') + '*'
    },
    on: {
      "change": function($event) {
        _vm.user.province = $event
      }
    }
  }, _vm._l((_vm.provinces), function(province) {
    return _c('option', [_vm._v(_vm._s(province))])
  })), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.phone,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.phone') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.phone = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.nir,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.NIR') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.nir = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.tps,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.GST')
    },
    on: {
      "input": function($event) {
        _vm.user.tps = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.tvq,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.QST')
    },
    on: {
      "input": function($event) {
        _vm.user.tvq = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.cigle,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.cigle') + '*'
    },
    on: {
      "input": function($event) {
        _vm.user.cigle = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.fax,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.fax')
    },
    on: {
      "input": function($event) {
        _vm.user.fax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "value": _vm.user.email,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyInfo.email')
    },
    on: {
      "input": function($event) {
        _vm.user.email = $event
      }
    }
  }), _vm._v(" "), _c('regular-input-file', {
    staticClass: "col-12 col-md-6 form-group",
    attrs: {
      "disabled": !_vm.isAdmin,
      "name": "logo",
      "placeholder": _vm.$t('Settings.modifyInfo.logo')
    },
    on: {
      "input": function($event) {
        _vm.user.logo = $event
      }
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "m-1 img-fluid mini",
    attrs: {
      "id": "logo",
      "src": _vm.user.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.user.driverComment,
      "label": _vm.$t('Settings.modifyInfo.driverComment')
    },
    on: {
      "change": function($event) {
        _vm.user.driverComment = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.modifyFormFilled || !_vm.isAdmin
    },
    on: {
      "click": function($event) {
        _vm.submitInfo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Settings.modifyInfo.submit')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('small', [_vm._v("* " + _vm._s(_vm.$t('Settings.modifyInfo.disclaimer')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-6",
    attrs: {
      "id": "changePass"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('Settings.modifyPass.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.changePass.email,
      "type": "text",
      "placeholder": _vm.$t('Settings.modifyPass.email') + '*'
    },
    on: {
      "input": function($event) {
        _vm.changePass.email = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.changePass.oldPass,
      "type": "password",
      "placeholder": _vm.$t('Settings.modifyPass.oldPass') + '*'
    },
    on: {
      "input": function($event) {
        _vm.changePass.oldPass = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.changePass.newPass,
      "type": "password",
      "placeholder": _vm.$t('Settings.modifyPass.newPass') + '*'
    },
    on: {
      "input": function($event) {
        _vm.changePass.newPass = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.changePass.newPassConfirm,
      "type": "password",
      "placeholder": _vm.$t('Settings.modifyPass.confirmPass') + '*'
    },
    on: {
      "input": function($event) {
        _vm.changePass.newPassConfirm = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.modifyPasswordFormFilled || !_vm.passwordConfirmation
    },
    on: {
      "click": function($event) {
        _vm.submitPass()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Settings.modifyPass.submit')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-3"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('Settings.modifyLang.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "w-100 btn",
    class: {
      'btn-kne-darkgrey': _vm.$store.state.i18n.locale === 'fr', 'btn-kne-orange': _vm.$store.state.i18n.locale === 'en'
    },
    attrs: {
      "type": "button",
      "value": "EN"
    },
    on: {
      "click": function($event) {
        _vm.changeLang('en')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "w-100 btn",
    class: {
      'btn-kne-darkgrey': _vm.$store.state.i18n.locale === 'en', 'btn-kne-orange': _vm.$store.state.i18n.locale === 'fr'
    },
    attrs: {
      "type": "button",
      "value": "FR"
    },
    on: {
      "click": function($event) {
        _vm.changeLang('fr')
      }
    }
  })])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ff2cde","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Settings.vue
// module id = 832
// module chunks = 1